// extracted by mini-css-extract-plugin
module.exports = {"responsiveWrap":"SubjectList_responsiveWrap__PIt7C","tabBarItem":"SubjectList_tabBarItem__1V6ns","subjectList":"SubjectList_subjectList__KjoGZ"};